var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericSettingsSlidersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.875h-7.5m-3.75-8.75h2.5-2.5zm11.25 0h-6.25 6.25zM1.875 7.5h7.5-7.5zm11.25 0h-1.25 1.25zm-11.25 4.375h1.25-1.25zM5.625 4.375a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM10.625 8.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM4.375 13.125a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  })));
}
export default SvgGenericSettingsSlidersIcon;